import { Article } from '@/gql/graphql';
import { PostExtract } from '@/services/post.service';
import clsx from 'clsx';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';
import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';

const BlogCard: FC<{
    article: PostExtract | Article;
}> = ({ article }) => {
    const headerUrl = article.headerImage?.url;

    return (
        <Link
            href={`/blog/${article.slug}`}
            className={
                //flex-shrink-0
                'w-full justify-between overflow-clip rounded-lg bg-white pb-1 shadow transition-all sm:hover:bg-cyprus-50 sm:hover:shadow-lg'
            }
        >
            <div
                /* @ts-expect-error CSS Variable */
                style={{ '--image-url': `url(${headerUrl})` }}
                className={clsx(
                    'bg-[image:var(--image-url)]',
                    `relative h-48 w-full bg-cover bg-center`
                )}
            >
                <span
                    className={
                        'absolute bottom-2 right-2 w-fit rounded-full bg-cyprus px-2 py-1 text-xs capitalize text-white'
                    }
                >
                    {article.category.replaceAll('_', ' ')}
                </span>
            </div>

            <div className={'m-4 flex-col justify-between gap-4'}>
                <h3 className={'font-body text-xl font-medium'}>
                    {/* <span className="hidden">
                        {article.title.length > 43
                            ? article.title.substring(0, 40) + '...'
                            : article.title}
                    </span> */}
                    <span className="">{article.title}</span>
                </h3>

                <div
                    className={
                        'my-4 inline-flex items-center gap-2 text-xs text-neutral-600'
                    }
                >
                    <Image
                        src={article.createdBy!.picture!}
                        alt={`Profile Picture of ${article.createdBy!.name}`}
                        width={25}
                        height={25}
                        className={'rounded-full'}
                    />
                    Publié le{' '}
                    {format(parseISO(article.publishedAt), 'dd/MM/yy', {
                        locale: fr
                    })}{' '}
                    par {article.createdBy!.name}
                </div>
            </div>
        </Link>
    );
};
export default BlogCard;
